import { format } from 'date-fns';
import { Box, Button, Divider, Stack } from '@mui/material';
import { Range } from './schedule';

interface TimeSlotButtonsProps {
  timeSlots: Range[];
  selectedStartTime: string;
  setSelectedStartTime: (selectedStartTime: string) => void;
  setSelectedEndTime: (selectedEndTime: string) => void;
  disabled: boolean;
  timeOfDay: string;
}

const TimeSlotButtons = ({
  timeSlots,
  selectedStartTime,
  setSelectedStartTime,
  setSelectedEndTime,
  disabled,
  timeOfDay,
}: TimeSlotButtonsProps) => (
  <Box sx={{ mb: 2 }}>
    <Divider sx={{ my: 2, color: 'GrayText' }}>
      {timeOfDay === 'AM' ? 'Morning' : 'Afternoon'}
    </Divider>
    <Stack direction="row" flexWrap="wrap" spacing={1}>
      {timeSlots?.map(slot => (
        <Button
          disabled={disabled}
          // Freshpaint ID for related event:
          // "Patient: Scheduling - Book Appointment Time Selected"
          id="scheduling-time-selected"
          variant={
            selectedStartTime !== slot.start.toISOString()
              ? 'outlined'
              : 'contained'
          }
          disableElevation
          onClick={() => {
            setSelectedStartTime(slot.start.toISOString());
            setSelectedEndTime(slot.end.toISOString());
          }}
        >
          {format(slot.start, 'hh:mm a')}
        </Button>
      ))}
    </Stack>
  </Box>
);

export default TimeSlotButtons;
